import { ACTION_TYPES as GENERAL_ACTION_TYPES } from "../redux/general/constants";

const data = {
    success : "",
    error: "",
    getSections: [],
    isDuplicateField: false
  };
  
  const sectionReducer = (state = data, action) => {
    switch (action.type) {
      case "success":
        return {
          ...state,
          success: action.payload,
        };

      case "error":
        return {
          ...state,
          error: action.payload,
        };

      case "getSections":
        return {
          ...state,
          getSections: action.payload,
        };

      case "isDuplicateField":
        return {
          ...state,
          isDuplicateField: action.payload,
        };

      case GENERAL_ACTION_TYPES.LOGOUT:
        return {
          ...state,
          getSections: []
        };

  
      default:
        return state;
    }
  };
  export default sectionReducer;
  